import { AnalyticsEvent } from './analytics-event.enum'

export abstract class AnalyticsService {
  abstract trackTiming(variableName: string, timingValue: number): void

  abstract trackPageView(path: string): void

  abstract trackEvent(event: AnalyticsEvent, props?: { [key: string]: string | number | boolean }): void
}
